// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var IOUtils = require("../../../shared/src/IOUtils.bs.js");
var ReactIO = require("../../../shared/src/ReactIO.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var ReactWindow = require("react-window");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");

var AutoSizer = {};

var _map = {"auto":"auto","smart":"smart","center":"center","end_":"end","start":"start"};

var _revMap = {"auto":"auto","smart":"smart","center":"center","end":"end_","start":"start"};

function tToJs(param) {
  return _map[param];
}

function tFromJs(param) {
  return _revMap[param];
}

var Alignment = {
  tToJs: tToJs,
  tFromJs: tFromJs
};

var _map$1 = {"forward":"forward","backward":"backward"};

function tToJs$1(param) {
  return param;
}

function tFromJs$1(param) {
  return _map$1[param];
}

var Direction = {
  tToJs: tToJs$1,
  tFromJs: tFromJs$1
};

var Scroll = {
  Alignment: Alignment,
  Direction: Direction
};

function fromJs(jsObj) {
  return {
          scrollDirection: Relude_Option.getOrElse("forward", _map$1[jsObj.scrollDirection]),
          scrollOffset: jsObj.scrollOffset,
          requestOrigin: jsObj.scrollUpdateWasRequested ? /* ScrollToCallback */1 : /* UserInteraction */0
        };
}

var Scroll$1 = {
  fromJs: fromJs
};

var $$Event = {
  Scroll: Scroll$1
};

function memoizeRow(renderChild) {
  return React.memo(renderChild, (function (prim, prim$1) {
                return ReactWindow.areEqual(prim, prim$1);
              }));
}

var MemoizedRow = {
  memoizeRow: memoizeRow
};

function useScrollRef(param) {
  return ReactIO.useRef(function (prim) {
              return prim;
            });
}

function scrollTo(scrollOffset) {
  return function (param) {
    return Relude_IO.map((function (param) {
                  return Relude_Option.fold(undefined, (function (__x) {
                                __x.scrollTo(scrollOffset);
                                
                              }), param);
                }), param);
  };
}

function scrollToItem(index, alignOpt) {
  var align = alignOpt !== undefined ? alignOpt : "auto";
  return function (param) {
    return Relude_IO.map((function (param) {
                  return Relude_Option.fold(undefined, (function (__x) {
                                __x.scrollToItem(index, _map[align]);
                                
                              }), param);
                }), param);
  };
}

function makeProps(itemKey, onScroll, onItemsRendered) {
  var arg = Relude_Option.map((function (itemKey) {
          return Curry.__2(itemKey);
        }), itemKey);
  var arg$1 = Relude_Option.map((function (onItemsRendered, $$event) {
          return IOUtils.unsafeRunHandledAsync(Curry._1(onItemsRendered, $$event));
        }), onItemsRendered);
  var arg$2 = Relude_Option.map((function (param, param$1) {
          return Relude_Globals.$great$great(fromJs, param, param$1);
        }), onScroll);
  return function (param) {
    return function (param$1, param$2, param$3) {
      var func = function (param$4, param$5, param$6, param$7, param$8, param$9, param$10, param$11, param$12, param$13, param$14, param$15, param$16, param$17, param$18) {
        var tmp = {
          children: param,
          height: param$3,
          itemCount: param$5,
          itemSize: param$8,
          width: param$16
        };
        if (param$1 !== undefined) {
          tmp.className = Caml_option.valFromOption(param$1);
        }
        if (param$2 !== undefined) {
          tmp.direction = (function () {
                switch (Caml_option.valFromOption(param$2)) {
                  case "leftToRight" :
                      return "ltr";
                  case "rightToLeft" :
                      return "rtl";
                  
                }
              })();
        }
        if (param$4 !== undefined) {
          tmp.initialScrollOffset = Caml_option.valFromOption(param$4);
        }
        if (param$6 !== undefined) {
          tmp.itemData = Caml_option.valFromOption(param$6);
        }
        if (param$7 !== undefined) {
          tmp.itemKey = Caml_option.valFromOption(param$7);
        }
        if (param$9 !== undefined) {
          tmp.layout = Caml_option.valFromOption(param$9);
        }
        if (param$10 !== undefined) {
          tmp.onItemsRendered = Caml_option.valFromOption(param$10);
        }
        if (param$11 !== undefined) {
          tmp.onScroll = Caml_option.valFromOption(param$11);
        }
        if (param$12 !== undefined) {
          tmp.overscanCount = Caml_option.valFromOption(param$12);
        }
        if (param$13 !== undefined) {
          tmp.ref = Caml_option.valFromOption(param$13);
        }
        if (param$14 !== undefined) {
          tmp.style = Caml_option.valFromOption(param$14);
        }
        if (param$15 !== undefined) {
          tmp.useIsScrolling = Caml_option.valFromOption(param$15);
        }
        if (param$17 !== undefined) {
          tmp.key = Caml_option.valFromOption(param$17);
        }
        return tmp;
      };
      return function (param, param$1) {
        var func$1 = Curry._2(func, param, param$1);
        return function (param, param$1) {
          var func$2 = Curry._3(func$1, param, arg, param$1);
          return function (param) {
            return Curry._3(func$2, param, arg$1, arg$2);
          };
        };
      };
    };
  };
}

var Fixed = {
  useScrollRef: useScrollRef,
  scrollTo: scrollTo,
  scrollToItem: scrollToItem,
  makeProps: makeProps
};

function useScrollRef$1(param) {
  return ReactIO.useRef(function (prim) {
              return prim;
            });
}

function scrollTo$1(scrollOffset) {
  return function (param) {
    return Relude_IO.map((function (param) {
                  return Relude_Option.fold(undefined, (function (__x) {
                                __x.scrollTo(scrollOffset);
                                
                              }), param);
                }), param);
  };
}

function scrollToItem$1(index, alignOpt) {
  var align = alignOpt !== undefined ? alignOpt : "auto";
  return function (param) {
    return Relude_IO.map((function (param) {
                  return Relude_Option.fold(undefined, (function (__x) {
                                __x.scrollToItem(index, _map[align]);
                                
                              }), param);
                }), param);
  };
}

function resetAfterIndex(index, shouldForceUpdate) {
  return function (param) {
    return Relude_IO.map((function (param) {
                  return Relude_Option.fold(undefined, (function (__x) {
                                __x.resetAfterIndex(index, shouldForceUpdate);
                                
                              }), param);
                }), param);
  };
}

function makeProps$1(onScroll, itemKey, onItemsRendered) {
  var arg = Relude_Option.map((function (itemKey) {
          return Curry.__2(itemKey);
        }), itemKey);
  var arg$1 = Relude_Option.map((function (onItemsRendered, $$event) {
          return IOUtils.unsafeRunHandledAsync(Curry._1(onItemsRendered, $$event));
        }), onItemsRendered);
  var arg$2 = Relude_Option.map((function (param, param$1) {
          return Relude_Globals.$great$great(fromJs, param, param$1);
        }), onScroll);
  return function (param) {
    return function (param$1, param$2, param$3) {
      var func = function (param$4, param$5, param$6, param$7, param$8, param$9, param$10, param$11, param$12, param$13, param$14, param$15, param$16, param$17, param$18, param$19) {
        var tmp = {
          children: param,
          estimatedItemSize: param$3,
          height: param$4,
          itemCount: param$6,
          itemSize: param$9,
          width: param$17
        };
        if (param$1 !== undefined) {
          tmp.className = Caml_option.valFromOption(param$1);
        }
        if (param$2 !== undefined) {
          tmp.direction = (function () {
                switch (Caml_option.valFromOption(param$2)) {
                  case "leftToRight" :
                      return "ltr";
                  case "rightToLeft" :
                      return "rtl";
                  
                }
              })();
        }
        if (param$5 !== undefined) {
          tmp.initialScrollOffset = Caml_option.valFromOption(param$5);
        }
        if (param$7 !== undefined) {
          tmp.itemData = Caml_option.valFromOption(param$7);
        }
        if (param$8 !== undefined) {
          tmp.itemKey = Caml_option.valFromOption(param$8);
        }
        if (param$10 !== undefined) {
          tmp.layout = Caml_option.valFromOption(param$10);
        }
        if (param$11 !== undefined) {
          tmp.onItemsRendered = Caml_option.valFromOption(param$11);
        }
        if (param$12 !== undefined) {
          tmp.onScroll = Caml_option.valFromOption(param$12);
        }
        if (param$13 !== undefined) {
          tmp.overscanCount = Caml_option.valFromOption(param$13);
        }
        if (param$14 !== undefined) {
          tmp.ref = Caml_option.valFromOption(param$14);
        }
        if (param$15 !== undefined) {
          tmp.style = Caml_option.valFromOption(param$15);
        }
        if (param$16 !== undefined) {
          tmp.useIsScrolling = Caml_option.valFromOption(param$16);
        }
        if (param$18 !== undefined) {
          tmp.key = Caml_option.valFromOption(param$18);
        }
        return tmp;
      };
      return function (param) {
        var func$1 = Curry._1(func, param);
        return function (param, param$1) {
          var func$2 = Curry._2(func$1, param, param$1);
          return function (param, param$1) {
            var func$3 = Curry._3(func$2, param, arg, param$1);
            return function (param) {
              return Curry._3(func$3, param, arg$1, arg$2);
            };
          };
        };
      };
    };
  };
}

var Variable = {
  useScrollRef: useScrollRef$1,
  scrollTo: scrollTo$1,
  scrollToItem: scrollToItem$1,
  resetAfterIndex: resetAfterIndex,
  makeProps: makeProps$1
};

var List = {
  $$Event: $$Event,
  MemoizedRow: MemoizedRow,
  Fixed: Fixed,
  Variable: Variable
};

function fromJs$1(jsObj) {
  return {
          horizontalScrollDirection: Relude_Option.getOrElse("forward", _map$1[jsObj.horizontalScrollDirection]),
          scrollLeft: jsObj.scrollLeft,
          scrollTop: jsObj.scrollTop,
          requestOrigin: jsObj.scrollUpdateWasRequested ? /* ScrollToCallback */1 : /* UserInteraction */0,
          verticalScrollDirection: Relude_Option.getOrElse("forward", _map$1[jsObj.verticalScrollDirection])
        };
}

var Scroll$2 = {
  fromJs: fromJs$1
};

var $$Event$1 = {
  Scroll: Scroll$2
};

function memoizeRow$1(renderChild) {
  return React.memo(renderChild, (function (prim, prim$1) {
                return ReactWindow.areEqual(prim, prim$1);
              }));
}

var MemoizedGridItem = {
  memoizeRow: memoizeRow$1
};

function useScrollRef$2(param) {
  return ReactIO.useRef(function (prim) {
              return prim;
            });
}

function scrollTo$2(scrollLeft, scrollTop) {
  return function (param) {
    return Relude_IO.map((function (param) {
                  return Relude_Option.fold(undefined, (function (__x) {
                                __x.scrollTo({
                                      scrollLeft: scrollLeft,
                                      scrollTop: scrollTop
                                    });
                                
                              }), param);
                }), param);
  };
}

function scrollToItem$2(columnIndex, rowIndex, alignOpt) {
  var align = alignOpt !== undefined ? alignOpt : "auto";
  return function (param) {
    return Relude_IO.map((function (param) {
                  return Relude_Option.fold(undefined, (function (__x) {
                                __x.scrollToItem({
                                      align: _map[align],
                                      columnIndex: columnIndex,
                                      rowIndex: rowIndex
                                    });
                                
                              }), param);
                }), param);
  };
}

function makeProps$2(onScroll, onItemsRendered) {
  var arg = Relude_Option.map((function (onItemsRendered, $$event) {
          return Relude_Option.fold(undefined, IOUtils.unsafeRunHandledAsync, Curry._1(onItemsRendered, $$event));
        }), onItemsRendered);
  var arg$1 = Relude_Option.map((function (param, param$1) {
          return Relude_Globals.$great$great(fromJs$1, param, param$1);
        }), onScroll);
  return function (param) {
    return function (param$1, param$2) {
      var func = function (param$3, param$4, param$5, param$6, param$7, param$8, param$9, param$10, param$11, param$12, param$13, param$14, param$15, param$16, param$17, param$18, param$19, param$20, param$21) {
        var tmp = {
          children: param,
          columnCount: param$2,
          columnWidth: param$3,
          height: param$5,
          rowCount: param$15,
          rowHeight: param$16,
          width: param$19
        };
        if (param$1 !== undefined) {
          tmp.className = Caml_option.valFromOption(param$1);
        }
        if (param$4 !== undefined) {
          tmp.direction = (function () {
                switch (Caml_option.valFromOption(param$4)) {
                  case "leftToRight" :
                      return "ltr";
                  case "rightToLeft" :
                      return "rtl";
                  
                }
              })();
        }
        if (param$6 !== undefined) {
          tmp.initialScrollLeft = Caml_option.valFromOption(param$6);
        }
        if (param$7 !== undefined) {
          tmp.initialScrollTop = Caml_option.valFromOption(param$7);
        }
        if (param$8 !== undefined) {
          tmp.itemData = Caml_option.valFromOption(param$8);
        }
        if (param$9 !== undefined) {
          tmp.itemKey = Caml_option.valFromOption(param$9);
        }
        if (param$10 !== undefined) {
          tmp.onItemsRendered = Caml_option.valFromOption(param$10);
        }
        if (param$11 !== undefined) {
          tmp.onScroll = Caml_option.valFromOption(param$11);
        }
        if (param$12 !== undefined) {
          tmp.overscanColumnCount = Caml_option.valFromOption(param$12);
        }
        if (param$13 !== undefined) {
          tmp.overscanRowCount = Caml_option.valFromOption(param$13);
        }
        if (param$14 !== undefined) {
          tmp.ref = Caml_option.valFromOption(param$14);
        }
        if (param$17 !== undefined) {
          tmp.style = Caml_option.valFromOption(param$17);
        }
        if (param$18 !== undefined) {
          tmp.useIsScrolling = Caml_option.valFromOption(param$18);
        }
        if (param$20 !== undefined) {
          tmp.key = Caml_option.valFromOption(param$20);
        }
        return tmp;
      };
      return function (param) {
        var func$1 = Curry._1(func, param);
        return function (param, param$1) {
          var func$2 = Curry._2(func$1, param, param$1);
          return function (param, param$1, param$2, param$3) {
            return Curry._6(func$2, param, param$1, param$2, param$3, arg, arg$1);
          };
        };
      };
    };
  };
}

var Fixed$1 = {
  useScrollRef: useScrollRef$2,
  scrollTo: scrollTo$2,
  scrollToItem: scrollToItem$2,
  makeProps: makeProps$2
};

function useScrollRef$3(param) {
  return ReactIO.useRef(function (prim) {
              return prim;
            });
}

function scrollTo$3(scrollLeft, scrollTop) {
  return function (param) {
    return Relude_IO.map((function (param) {
                  return Relude_Option.fold(undefined, (function (__x) {
                                __x.scrollTo({
                                      scrollLeft: scrollLeft,
                                      scrollTop: scrollTop
                                    });
                                
                              }), param);
                }), param);
  };
}

function scrollToItem$3(columnIndex, rowIndex, alignOpt) {
  var align = alignOpt !== undefined ? alignOpt : "auto";
  return function (param) {
    return Relude_IO.map((function (param) {
                  return Relude_Option.fold(undefined, (function (__x) {
                                __x.scrollToItem({
                                      align: _map[align],
                                      columnIndex: columnIndex,
                                      rowIndex: rowIndex
                                    });
                                
                              }), param);
                }), param);
  };
}

function resetAfterColumnIndex(index, shouldForceUpdate) {
  return function (param) {
    return Relude_IO.map((function (param) {
                  return Relude_Option.fold(undefined, (function (__x) {
                                __x.resetAfterColumnIndex(index, shouldForceUpdate);
                                
                              }), param);
                }), param);
  };
}

function resetAfterIndices(columnIndex, rowIndex, shouldForceUpdate) {
  return function (param) {
    return Relude_IO.map((function (param) {
                  return Relude_Option.fold(undefined, (function (__x) {
                                __x.resetAfterIndices({
                                      columnIndex: columnIndex,
                                      rowIndex: rowIndex,
                                      shouldForceUpdate: shouldForceUpdate
                                    });
                                
                              }), param);
                }), param);
  };
}

function resetAfterRowIndex(index, shouldForceUpdate) {
  return function (param) {
    return Relude_IO.map((function (param) {
                  return Relude_Option.fold(undefined, (function (__x) {
                                __x.resetAfterRowIndex(index, shouldForceUpdate);
                                
                              }), param);
                }), param);
  };
}

function makeProps$3(onScroll, onItemsRendered) {
  var arg = Relude_Option.map((function (onItemsRendered, $$event) {
          return IOUtils.unsafeRunHandledAsync(Curry._1(onItemsRendered, $$event));
        }), onItemsRendered);
  var arg$1 = Relude_Option.map((function (param, param$1) {
          return Relude_Globals.$great$great(fromJs$1, param, param$1);
        }), onScroll);
  return function (param) {
    return function (param$1, param$2) {
      var func = function (param$3, param$4, param$5, param$6, param$7, param$8, param$9, param$10, param$11, param$12, param$13, param$14, param$15, param$16, param$17, param$18, param$19, param$20, param$21, param$22, param$23) {
        var tmp = {
          children: param,
          columnCount: param$2,
          columnWidth: param$3,
          height: param$7,
          rowCount: param$17,
          width: param$21
        };
        if (param$1 !== undefined) {
          tmp.className = Caml_option.valFromOption(param$1);
        }
        if (param$4 !== undefined) {
          tmp.direction = (function () {
                switch (Caml_option.valFromOption(param$4)) {
                  case "leftToRight" :
                      return "ltr";
                  case "rightToLeft" :
                      return "rtl";
                  
                }
              })();
        }
        if (param$5 !== undefined) {
          tmp.estimatedColumnWidth = Caml_option.valFromOption(param$5);
        }
        if (param$6 !== undefined) {
          tmp.estimatedRowHeight = Caml_option.valFromOption(param$6);
        }
        if (param$8 !== undefined) {
          tmp.initialScrollLeft = Caml_option.valFromOption(param$8);
        }
        if (param$9 !== undefined) {
          tmp.initialScrollTop = Caml_option.valFromOption(param$9);
        }
        if (param$10 !== undefined) {
          tmp.itemData = Caml_option.valFromOption(param$10);
        }
        if (param$11 !== undefined) {
          tmp.itemKey = Caml_option.valFromOption(param$11);
        }
        if (param$12 !== undefined) {
          tmp.onItemsRendered = Caml_option.valFromOption(param$12);
        }
        if (param$13 !== undefined) {
          tmp.onScroll = Caml_option.valFromOption(param$13);
        }
        if (param$14 !== undefined) {
          tmp.overscanColumnCount = Caml_option.valFromOption(param$14);
        }
        if (param$15 !== undefined) {
          tmp.overscanRowCount = Caml_option.valFromOption(param$15);
        }
        if (param$16 !== undefined) {
          tmp.ref = Caml_option.valFromOption(param$16);
        }
        if (param$18 !== undefined) {
          tmp.rowHeight = Caml_option.valFromOption(param$18);
        }
        if (param$19 !== undefined) {
          tmp.style = Caml_option.valFromOption(param$19);
        }
        if (param$20 !== undefined) {
          tmp.useIsScrolling = Caml_option.valFromOption(param$20);
        }
        if (param$22 !== undefined) {
          tmp.key = Caml_option.valFromOption(param$22);
        }
        return tmp;
      };
      return function (param) {
        var func$1 = Curry._1(func, param);
        return function (param, param$1, param$2, param$3) {
          var func$2 = Curry._4(func$1, param, param$1, param$2, param$3);
          return function (param, param$1, param$2, param$3) {
            return Curry._6(func$2, param, param$1, param$2, param$3, arg, arg$1);
          };
        };
      };
    };
  };
}

var Variable$1 = {
  useScrollRef: useScrollRef$3,
  scrollTo: scrollTo$3,
  scrollToItem: scrollToItem$3,
  resetAfterColumnIndex: resetAfterColumnIndex,
  resetAfterIndices: resetAfterIndices,
  resetAfterRowIndex: resetAfterRowIndex,
  makeProps: makeProps$3
};

var Grid = {
  $$Event: $$Event$1,
  MemoizedGridItem: MemoizedGridItem,
  Fixed: Fixed$1,
  Variable: Variable$1
};

exports.AutoSizer = AutoSizer;
exports.Scroll = Scroll;
exports.List = List;
exports.Grid = Grid;
/* react Not a pure module */
